module.exports = __webpack_public_path__ + "static/media/white_arrow_down.f07af376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/white_arrow_down.svg
// module id = 1455
// module chunks = 2